export const ICONS_NAMES: string[] = [
  'message'
];
